import { IFormQualifierAttribute } from "../../../model/form/FormQualifierAttribute";
import FormInputValuePresentationModel, {
  IFormInputValuePresentationModel
} from "./FormInputValuePresentationModel";

export interface TFormQualifierAttributePresentationModel {
  formAttributeId: number;
  attributeName: string;
  attributeType: string;
  id: number;
  labelVisible: boolean;
  name: string;
  orderNumberInsertDisplay: number;
  qualifierId: number;
  required: boolean;
  tooltip: string;
  attributeCode: string;
  isRequiredFlagVisible: boolean;
  values: IFormInputValuePresentationModel[];
}
export interface IFormQualifierAttributePresentationModel
  extends TFormQualifierAttributePresentationModel {
  values: IFormInputValuePresentationModel[];
}
const isAttributeRequired = (
  data: IFormQualifierAttribute,
  isParentSectionRequired: boolean
) => {
  let attributeRequired: boolean = false;
  if (isParentSectionRequired && data.required) {
    attributeRequired = true;
  }
  return attributeRequired;
};

const FormQualifierAttributePresentationModel = (
  data: IFormQualifierAttribute,
  isParentSectionRequired: boolean,
  segmentRowsChanged: number[],
  requiredQualifiers: number[]
): IFormQualifierAttributePresentationModel => {
  let _isRequiredFlagVisible = isAttributeRequired(
    data,
    isParentSectionRequired
  );
  return {
    formAttributeId: data.formAttributeId,
    attributeName: data.attributeName,
    attributeType: data.attributeType,
    id: data.id,
    labelVisible: data.labelVisible,
    name: data.name,
    orderNumberInsertDisplay: data.orderNumberInsertDisplay,
    qualifierId: data.qualifierId,
    required: data.required,
    tooltip: data.tooltip,
    attributeCode: data.attributeCode,
    isRequiredFlagVisible: _isRequiredFlagVisible,
    values: data.values.map(item =>
      FormInputValuePresentationModel(
        item,
        _isRequiredFlagVisible,
        segmentRowsChanged,
        requiredQualifiers
      )
    )
  };
};

export default FormQualifierAttributePresentationModel;
